var getFormFields = require('cerebral-module-forms/helpers/getFormFields')

export default function getInvalidNotHiddenFormFields(form) {
  var formFields = getFormFields(form)

  return Object.keys(formFields)
    .filter(function(key) {
      if (formFields[key].hidden) {
        return false
      }
      return !formFields[key].isValid
    })
    .reduce(function(invalidFields, key) {
      invalidFields[key] = formFields[key]
      return invalidFields
    }, {})
}



// WEBPACK FOOTER //
// ./src/modules/user/helpers/getInvalidNotHiddenFormFields.js